/**
 * Region for styles*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

import { IndexActivityLog } from './pages/keyword/activityLog/IndexActivityLog';
import { WebProductsSearch } from './pages/product/webproducts/Search';
import { ResearchList } from './pages/suppliers/research/ResearchList';
import LayoutKeyword from './pages/keyword/management/LayoutKeyword';
import LayoutMiniSite from './pages/minisites/management/LayoutMiniSite';
import LayoutCrawlers from './pages/crawlers/management/LayoutCrawlers';
import LayoutBrokenUrls from './pages/brokenurls/management/LayoutBrokenUrls';
import LayoutCompaniesWithoutKeyContacts from './pages/companies/management/LayoutCompaniesWithoutKeyContacts';
import LayoutKeywordAnalyzer from './pages/keyword/management/LayoutKeywordAnalyzer';
/**
 * Region for custom modules*/
import Home from './pages/Home';

class ContainerRouter extends Component {
    render() {
        return (
            <Router>
                <Switch>
                    <Redirect exact from="/LayoutMiniSite" to="/LayoutMiniSite/List" />
                    <Route exact path="/"><Home /></Route>
                    <Route exact path="/indexActivityLog/dashboard"><IndexActivityLog /></Route>
                    <Route exact path="/indexActivityLog/activity"><IndexActivityLog /></Route>
                    <Route exact path="/content/webproducts/search"><WebProductsSearch /></Route>
                    <Route exact path="/ResearchList"><ResearchList /></Route>                    
                    <Route exact path="/keywordManagement"><LayoutKeyword /></Route>
                    <Route path="/LayoutMiniSite"><LayoutMiniSite /></Route>    
                    <Route exact path="/LayoutCrawlers"><LayoutCrawlers /></Route>  
                    <Route exact path="/LayoutBrokenUrls"><LayoutBrokenUrls /></Route>  
                    <Route exact path="/LayoutCompaniesWithoutKeyContacts"><LayoutCompaniesWithoutKeyContacts /></Route>  
                    <Route exact path="/LayoutKeywordAnalyzer"><LayoutKeywordAnalyzer /></Route>  
                </Switch>
            </Router>
        );   
    }  
}
export default connect()(ContainerRouter);